/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaMatch = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        team1: {
            type: 'TeamSmall',
            isRequired: true,
        },
        team2: {
            type: 'TeamSmall',
            isRequired: true,
        },
        events: {
            type: 'array',
            contains: {
                type: 'EventType',
            },
            isRequired: true,
        },
        startTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
        endTime: {
            type: 'string',
            isRequired: true,
            format: 'date-time',
        },
    },
} as const;
